import React, { useEffect } from 'react'
import { Switch, Redirect, Route, useLocation } from 'react-router-dom'
import SignUp from './UserSignUp/SignUp'
import SignUpCardholder from './UserSignUp/SignUpCardholder'
import WelcomePage from './WelcomePage'
import ResellerWelcomePage from './ResellerWelcomePage'
import LoginPage from './LoginPage'
import ForgotResetPasswordPage from './ForgotResetPasswordPage'
import UnlockInstructionsPage from './UnlockInstructionsPage'
import ConfirmUnlockPage from './ConfirmUnlockPage'

const PublicRoutes = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <Switch>
      <Route exact path="/card-benefit" component={WelcomePage} />
      <Route exact path="/welcome" component={ResellerWelcomePage} />
      <Route exact path="/amiti" component={ResellerWelcomePage} />
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/forgot-password" component={ForgotResetPasswordPage} />
      <Route exact path="/reset-password/:token" component={ForgotResetPasswordPage} />
      <Route exact path="/unlock-instructions" component={UnlockInstructionsPage} />
      <Route exact path="/confirm-unlock/:token" component={ConfirmUnlockPage} />
      <Route exact path="/sign-up" component={SignUp} />
      <Route exact path="/free-trial-sign-up" render={() => <SignUp freeTrial />} />
      <Route exact path="/card-benefit/sign-up" component={SignUpCardholder} />
      <Redirect to="/welcome" />
    </Switch>
  )
}

export default PublicRoutes
